//6.
import {reactive} from 'vue'
//5. event is to store data returned from api
export default reactive({flashMessage:'', event:null})

